import React from "react";
import styles from "../dummyDashboard/dummyDashboard.module.css";
import avatar from "utils/assets/Profile_Photo.svg";

function StatItem({ label, value, unit }) {
  return (
    <div className={styles.statItem}>
      <span className={styles.statLabel}>{label}</span>
      <div className={styles.statValueRow}>
        <span className={styles.statValue}>{value}</span>
        {unit ? <span className={styles.statUnit}>{unit}</span> : null}
      </div>
    </div>
  );
}

 // footer items not used in exact large card

function Card({ name, oxygen, color }) {
  return (
    <div className={styles.cardLarge}>
      <div className={`${styles.cardHeader} ${styles.cardHeaderLarge}`}>
        <img className={styles.avatar} src={avatar} alt="Profile" />
        <div className={styles.name}>{name}</div>
      </div>
      <div className={`${styles.cardAccentLarge} ${styles[color]}`} />
      <div className={styles.cardBodyLarge}>
         <div className={styles.colLeftLarge}>
          <div className={styles.sectionTitle}>Oxygen</div>
          <div className={styles.oxygenRow}>
            <span className={styles.oxygenValue} data-color={color}>
              {oxygen}
            </span>
            <span className={styles.percent}>%</span>
          </div>
          <div className={styles.sectionTitle}>Pulse Rate</div>
          <div className={styles.heartRateRow}>
            <span className={styles.heartValue}>77</span>
            <span className={styles.heartUnit}>bpm</span>
          </div>
        </div>
         <div className={styles.midColLarge}>
          <StatItem label="SpO₂ Variability" value="45" unit="mL/s" />
          <StatItem label="Perfusion Index" value="11" unit="%" />
          <StatItem label="HRV" value="55" unit="ms" />
        </div>
          <div className={styles.envColLarge}>
            <div>
              <div className={styles.envLabel}>Humidity</div>
              <div className={styles.envRow}>
                <span className={styles.envValue}>48</span>
                <span className={styles.envUnit}>%</span>
              </div>
            </div>
            <div>
              <div className={styles.envLabel}>Altitude</div>
              <div className={styles.envRow}>
                <span className={styles.envValue}>512</span>
                <span className={styles.envUnit}>feet</span>
              </div>
            </div>
            <div>
              <div className={styles.envLabel}>Temperature</div>
              <div className={styles.envRow}>
                <span className={styles.envValue}>60</span>
                <span className={styles.envUnit}>°F</span>
              </div>
            </div>
            <div>
              <div className={styles.envLabel}>Air Quality Index</div>
              <div className={styles.envRow}>
                <span className={styles.envValue}>75</span>
                <span className={styles.envUnit + " " + styles.envModerate}>moderate</span>
              </div>
            </div>
          </div>
        </div>
       <div className={styles.vDividerRight} />
    </div>
  );
}

export default function FourDashboard() {
  const CARDS = [
    { id: 1, name: "Jennifer Adamson", oxygen: 98, color: "teal" },
    { id: 2, name: "Jennifer Adamson", oxygen: 90, color: "orange" },
    { id: 3, name: "Jennifer Adamson", oxygen: 88, color: "red" },
    { id: 4, name: "Jennifer Adamson", oxygen: 98, color: "teal" },
  ];

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        
        <button className={styles.closeBtn} aria-label="close">
          ×
        </button>
      </div>
      <div className={styles.gridFour}>
        {CARDS.map((c) => (
          <Card key={c.id} name={c.name} oxygen={c.oxygen} color={c.color} />
        ))}
      </div>
    </div>
  );
}